import React from 'react';
import styled from "styled-components";
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { SpaceBetweenRow } from '@features/settings/pages/StyleComponents';
import Colours from '@shared/ui/atoms/Colours';
import { useSelector } from "react-redux";
import { CustomNonWorkingDays, NonWorkingDays } from '@features/holidays/services/HolidayService';
import { iconPackPath } from '@shared/utils/WhereaboutsHelper';
import { FreeBusyStatus } from '@features/whereabouts/services/WhereaboutOptions';
import { selectIconPack } from '@shared/store/auth.duck';
import { PopupPosition } from "./HolidayInfoAndApprovalPopup";
import { HolidayPopupShell } from "./HolidayPopupShell";

export function NonWorkingDayInfoPopup(props: Props) {
  const iconPack = useSelector(selectIconPack);

  return (
    <HolidayPopupShell isVisible={props.isVisible}
                       triggerRect={props.triggerRect}
                       popupPositioning={props.popupPositioning}>
      <SpaceBetweenRow style={{alignItems: 'center', marginBottom: 4}}>
        <BodyRegular colour={Colours.darkGreen} weight={600}>Non working day</BodyRegular>
        <LeaveImage src={iconPackPath(iconPack, 'NotWorking.svg', FreeBusyStatus.FREE)} alt={""} />
      </SpaceBetweenRow>
    </HolidayPopupShell>
  )
}

interface Props {
  nonWorkingDay: NonWorkingDays | CustomNonWorkingDays;
  popupPositioning?: PopupPosition;
  isVisible: boolean;
  triggerRect?: DOMRect;
}

const LeaveImage = styled.img`
  max-width: 40px;
  max-height: 40px;
`
